import { Button, CircularProgress, Grid, Grid2, InputAdornment, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IService } from "sierra";
import { version } from '../../../../package.json'
import { useApp } from "../../../contexts/AppContext";
import LangDropdown from "../../../components/LangDropdown";

export default function Login() {
    const { user, login, fetchUser } = useAuth()
    const navigate = useNavigate();
    const location = useLocation()
    const { translate, lang } = useApp()
    const [searchParams, setSearchParams] = useSearchParams()

    const service: IService = useMemo(() => location.state?.service, [location])

    const redirect = useMemo(() => searchParams.get('redirect'), [searchParams])

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        fetchUser()
    }, [])

    useEffect(() => {
        const hrefUrl = new URL(window.location.href).origin + new URL(window.location.href).pathname
        if (searchParams.get('redirect') === hrefUrl) {
            setSearchParams(params => {
                params.delete('redirect');
                return params;
            })
        }
    }, [searchParams])

    useEffect(() => {
        if (!user) return
        if (redirect) {
            console.log('redirecting to', redirect)
            window.location.href = redirect;
            return
        }
        if (user.role === 'customer') if (!service) { navigate('/') } else { navigate('/order', { state: { service: service } }) }
        else navigate('/system')
    }, [user])

    const handleLogin = () => {
        setSubmitting(true)
        login(email, password, {
            onSuccess: () => setSubmitting(false),
            onError: () => setSubmitting(false)
        });
    }

    // useEffect(() => console.log(service), [])

    return (
        <Grid2 container height={'100vh'} flexDirection={{ xs: 'column', md: 'row' }}>
            <Grid2 sx={{ position: 'absolute', bottom: 0, left: 10 }}>
                <Typography color='primary.dark'>v{version}</Typography>
            </Grid2>
            <Grid2 container size={'grow'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                <Grid2 container flexDirection={'column'} gap={7} minWidth={{ lg: 500, xs: 'auto' }}>
                    <Grid2>
                        <LangDropdown />
                    </Grid2>
                    <Grid2 container flexDirection={'column'}>
                        <Grid2>
                            <Typography variant="h2" fontWeight={'bold'}>{translate("Dashboard")}</Typography>
                        </Grid2>
                        <Grid2>
                            <Typography variant="h2" fontWeight={'bold'}>{translate("Sierra")}</Typography>
                        </Grid2>
                    </Grid2>
                    <Grid2 container flexDirection={'column'} gap={3}>
                        <Grid2>
                            <TextField required autoComplete="username" name="email" onKeyUp={(e) => e.key === 'Enter' && handleLogin()} label={translate('Email')} size="small" fullWidth onChange={(e) => setEmail(e.target.value)} value={email} />
                        </Grid2>
                        <Grid2>
                            <TextField required autoComplete="current-password" name="password" onKeyUp={(e) => e.key === 'Enter' && handleLogin()} label={translate('Password')} size='small' type={showPass ? "text" : "password"} fullWidth onChange={(e) => setPassword(e.target.value)} value={password}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position={lang === 'ar' ? "end" : "start"} onClick={() => setShowPass(v => !v)} sx={{ cursor: 'pointer' }}>
                                                {showPass ? <VisibilityOff /> : <Visibility />}
                                            </InputAdornment>
                                        ),
                                    },
                                }} />
                        </Grid2>
                    </Grid2>
                    <Grid2 container flexDirection={'column'} gap={2}>
                        <Grid2>
                            <Button onClick={handleLogin} disabled={submitting} startIcon={submitting && <CircularProgress />} variant="contained" fullWidth>{translate("LOGIN")}</Button>
                        </Grid2>
                        <Grid2>
                            <Button onClick={() => navigate('/forgot-password', !service ? undefined : { state: { service: service } })}>{translate("Forgot password?")}</Button>
                        </Grid2>
                        <Grid2 container display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Grid2>
                                <Typography>{translate("Don't have an account yet?")}</Typography>
                            </Grid2>
                            <Grid2>
                                <Button onClick={() => navigate('/register', !service ? undefined : { state: { service: service } })}>{translate("register now!")}</Button>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 size={'grow'} sx={{ backgroundColor: (t) => t.palette.primary.main }} display={{ xs: 'none', md: 'flex' }} justifyContent={'center'} alignItems={'center'}>
                <img src="/sierra-logo.png" />
            </Grid2>
        </Grid2>
    )
}